module.exports = __webpack_public_path__ + "static/media/buy_report_user_1.2c9d2e56.png";